import { theme } from '../../styles/theme';

export const loginWeb = {
  width: '100%',
  minHeight: 'fit-content',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  padding: { mobile: '24px', desktop: '128px 24px' }
};

export const loginWebWrapper = {
  width: { tablet: '464px', desktop: '1096px' },
  position: 'relative'
};

export const loginWebBox = {
  backgroundColor: theme.palette.common.white,
  borderRadius: '16px',
  padding: { mobile: '24px 27px', tablet: '32px' }
};
